import type { currentCartV2 as currentCart } from '@wix/ecom';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { createExpressCheckoutPublicApi } from './expressCheckout/expressCheckoutPublicApi';

export function createInternalPublicApi({
  context,
}: {
  context: EcomPlatformViewerScriptContext;
}) {
  return {
    calculateCart: (
      ...args: Parameters<typeof context.cartService.calculateCart>
    ) => context.cartService.calculateCart(...args),
    updateCart: (...args: Parameters<typeof context.cartService.updateCart>) =>
      context.cartService.updateCart(...args),
    setDeliveryMethod: (
      ...args: Parameters<typeof context.cartService.setDeliveryMethod>
    ) => context.cartService.setDeliveryMethod(...args),
    removeDeliveryMethod: (
      ...args: Parameters<typeof context.cartService.removeDeliveryMethod>
    ) => context.cartService.removeDeliveryMethod(...args),
    placeOrder: (...args: Parameters<typeof context.cartService.placeOrder>) =>
      context.cartService.placeOrder(...args),
    expressCheckout: createExpressCheckoutPublicApi({ context }),
    addLineItemsToCurrentCart: async (
      options: currentCart.AddLineItemsToCurrentCartOptions,
    ) => {
      await context.currentCartService.addLineItemsToCurrentCart(options);
    },
  };
}
